module.exports = __webpack_public_path__ + "static/media/cancel.e87b8862.svg";